import { createPostListController } from '../../external/post-list-widget/controller';

export default createPostListController;
